var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__container"},[_c('div',{staticClass:"page__body"},[_c('register-form')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }